module.exports = __webpack_public_path__ + "static/assets/3724156c798fb9f1230c9bd1c877f1fd.png";